


const body = document.querySelector('body');
if(body.classList.contains('template-collection')){
  document.addEventListener("DOMContentLoaded", function() {
      document.querySelector(".first-grid-changer").addEventListener("click", function() {
        this.classList.add("active");
        document.querySelector(".second-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.add("grid--1-col-tablet-down");
          elements[i].classList.remove("grid--2-col-tablet-down");
        }
      });

      // Function to remove class .small--one-full when clicking on .second-grid-changer
      document.querySelector(".second-grid-changer").addEventListener("click", function() {
         this.classList.add("active");
        document.querySelector(".first-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove("grid--1-col-tablet-down");
          elements[i].classList.add("grid--2-col-tablet-down");
        }
      });
    });
}


if(body.classList.contains == 'template-product'){
  const headings = document.querySelectorAll('.tabs-heading');
        // Get all the p elements with class "tabs-content"
        const contents = document.querySelectorAll('.tabs-content');

        // Add click event listeners to each h1 element
        headings.forEach((heading) => {
            heading.addEventListener('click', () => {
                // Remove the "active" class from all p elements
                contents.forEach((content) => {
                    content.classList.remove('active');
                });

                // Get the ID of the clicked h1 element
                const targetId = heading.getAttribute('id');

                // Find the corresponding p element with the same ID and add the "active" class
                const targetContent = document.getElementById(targetId);
                targetContent.classList.add('active');
            });
        });
}

// Custom Flow


window.addEventListener("load", function () {
  const typeRadios = document.querySelectorAll('input[type="radio"][name="Type"]');
  const sizeRadios = document.querySelectorAll('input[type="radio"][name="Size"]');
  const customSizeInput = document.querySelector('input[type="radio"][value="Custom"]');
  const addonSection = document.querySelector('.custom_size_option_addon');
  const addonInputs = addonSection ? addonSection.querySelectorAll('input, textarea') : [];
  const sizeFieldset = sizeRadios.length ? sizeRadios[0].closest('fieldset') : null;

  // Store original name attributes
  const addonInputNameMap = new Map();
  addonInputs.forEach(input => {
    if (input.name) addonInputNameMap.set(input, input.name);
  });

  function showSizeOptions() {
    if (sizeFieldset) sizeFieldset.style.display = 'block';
  }

  function hideSizeOptions() {
    if (sizeFieldset) sizeFieldset.style.display = 'none';
  }

  function enableAddonInputs() {
    if (addonSection) addonSection.style.display = 'block';
    addonInputs.forEach(input => {
      input.disabled = false;
      const originalName = addonInputNameMap.get(input);
      if (originalName) input.setAttribute('name', originalName);
    });
  }

  function disableAddonInputs() {
    if (addonSection) addonSection.style.display = 'none';
    addonInputs.forEach(input => {
      input.disabled = true;
      input.removeAttribute('name');
      if (input.type === 'text' || input.tagName === 'TEXTAREA') input.value = '';
      if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
    });
  }

  function showAddonInputs() {
    enableAddonInputs();
  }

  function hideAddonInputs() {
    disableAddonInputs();
  }

  function handleSizeChange() {
    sizeRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.value === "Custom") {
          showAddonInputs();
        } else {
          hideAddonInputs();
        }
      });

      // In case it's already selected on page load
      if (radio.checked && radio.value === "Custom") {
        showAddonInputs();
      }
    });
  }

  function handleTypeChange() {
    typeRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.value === "Stitched") {
          showSizeOptions();
          handleSizeChange();
        } else {
          hideSizeOptions();
          hideAddonInputs();
        }
      });

      // Also check for pre-selected
      if (radio.checked && radio.value === "Stitched") {
        showSizeOptions();
        handleSizeChange();
      }
    });
  }

  function autoSelectIfOnlyOneTypeEnabled() {
    const enabled = Array.from(typeRadios).filter(radio => !radio.disabled);
    if (enabled.length === 1 && !enabled[0].checked) {
      enabled[0].checked = true;
      enabled[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // Initialization logic
  if (typeRadios.length) {
    handleTypeChange();
    autoSelectIfOnlyOneTypeEnabled();
  } else {
    showSizeOptions();
    handleSizeChange();
  }

  // Fallback: if no Type and Custom is selected
  if (!typeRadios.length && customSizeInput?.checked) {
    showAddonInputs();
  } else {
    hideAddonInputs();
  }
});





